import { RouteObject } from 'react-router-dom'
import { mapPlatformRoutesToPaths, extendPath } from '@wellesley/router'
import { MemoizedRemoteApp } from '../../features/remote-app/RemoteApp'

export const useAppsRoutes = () =>
  mapPlatformRoutesToPaths()?.map(({ path, url, name }) => ({
    path: extendPath(path),
    element: <MemoizedRemoteApp key={url} name={name} src={url} />,
  })) as RouteObject[]
